import { Fragment, useEffect, useState } from "react";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Card,
    Col,
    Container,
    Input,
    Label,
    Row,
} from "reactstrap";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import { ReportListTitle, ReportTitle } from "../../Utils/Constants";
import CommonTable from "../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { ensureDexieReady, getFieldValuesFromDexie, getFilteredPositionIds } from "../../db/DexieServises";
import MonthDropdown from "../CommonCompo/MonthDropdown";
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import CommonTableNew from "../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { dynamicImage } from "../../Utils";
import { Image } from "../../AbstractElements";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
import RevMonth from "../CommonCompo/RevMonth";

export default function EffortReport() {
    const unitId = useSelector((state: RootState) => state.orgUnit.id);
    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [effortData, setEffortData] = useState<any[]>([]);
    const [displayedData, setDisplayedData] = useState<any[]>(effortData);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedKey, setSelectedKey] = useState('');
    const [dropdownOptions, setDropdownOptions] = useState<[string, string][]>([]);
    const [selectedMonth, setSelectedMonth] = useState<string>('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const toggle = () => setDropdownOpen(prev => !prev);

    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');



    // Call team attendance API once on load (static date)
    useEffect(() => {
        if (selectedMonth) {
            handleSubmitAPI();
        }
    }, [selectedMonth, selectedIds, unitId]);

    const handleSubmitAPI = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }
        setLoading(true); // 👈 Stop loader
        await ensureDexieReady();
        const ids = await getFilteredPositionIds('Position', unitId);
        const positionIds = selectedIds.length > 0 ? selectedIds : ids;
        const month = selectedMonth;

        // console.log("📦 API Call Payload:", {
        //     position_id: positionIds,
        //     moye: month
        // });

        const url = `${serverUrl}${API.getEffortReport}`;
        const { status, data } = await getData(url, true, {
            position_id: positionIds,
            moye: month,
        });

        if (status === 200 && Array.isArray(data?.data)) {
            // console.log("📦 Raw API Data:", data?.data); // <-- add this
            setEffortData(data?.data);
            setLoading(false); // 👈 Stop loader

        } else {
            setEffortData([]); // fallback
        }
        setLoading(false); // 👈 Stop loader
    };


    useEffect(() => {
        const lower = searchText.toLowerCase();

        const filtered = effortData.filter((item) => {
            // ✅ Only filter by search text (not by selectedIds)
            return item?.EmployeeName?.toLowerCase().includes(lower) || item?.EmployeeCode?.toLowerCase().includes(lower) || item?.AmPosition?.toLowerCase().includes(lower) || item?.RmPosition?.toLowerCase().includes(lower) || item?.ZmPosition?.toLowerCase().includes(lower) || item?.Location?.toLowerCase().includes(lower) || item?.AgEmployeeStatusenda?.toLowerCase().includes(lower) || item?.EmployeeLevel?.toLowerCase().includes(lower)
        });

        setDisplayedData(filtered);
        // console.log("📊 Filtered Data:", filtered);
    }, [searchText, effortData]); // ✅ remove selectedIds from dependency

    const masColumns = [
        // { head: 'MAS Report Id', key: 'MasReportId' },
        { head: 'Employee Name', key: 'EmployeeName' },
        // { head: 'Company Id', key: 'CompanyId' },
        // { head: 'Org Unit Id', key: 'OrgUnitId' },
        { head: 'Org Unit Name', key: 'OrgUnitName' },
        // { head: 'Employee Id', key: 'EmployeeId' },
        { head: 'Employee Code', key: 'EmployeeCode' },
        { head: 'Employee Status', key: 'EmployeeStatus' },
        { head: 'Employee Position Code', key: 'EmployeePositionCode' },
        { head: 'Employee Position Name', key: 'EmployeePositionName' },
        { head: 'Employee Level', key: 'EmployeeLevel' },
        { head: 'Territory Name', key: 'TerritoryName' },
        { head: 'L1 Position', key: 'AmPosition' },
        // { head: 'AM Position Code', key: 'AmPositionCode' },
        { head: 'L2 Position', key: 'RmPosition' },
        // { head: 'RM Position Code', key: 'RmPositionCode' },
        { head: 'L3 Position', key: 'ZmPosition' },
        // { head: 'ZM Position Code', key: 'ZmPositionCode' },
        { head: 'Month Year', key: 'MonthYear' },
        { head: 'Working Days', key: 'WorkingDays' },
        { head: 'FWD', key: 'Fwd' },
        { head: 'NCA', key: 'Nca' },
        { head: 'Leave Days', key: 'LeaveDays' },
        { head: 'Joint Working', key: 'JointWorking' },
        { head: 'Total Primary', key: 'TotalPrimary' },
        { head: 'Primary Met', key: 'PrimaryMet' },
        { head: 'Primary VF Met', key: 'PrimaryVfMet' },
        { head: 'Primary DCR LM', key: 'PrimaryDcrLm' },
        { head: 'Primary DCR Average', key: 'PrimaryDcrAverage' },
        { head: 'Primary DCR VF Average', key: 'PrimaryDcrVfaverage' },
        { head: 'Missed Primary', key: 'MissedPrimary' },
        { head: 'Missed Primary Calls', key: 'MissedPrimaryCalls' },
        { head: 'POB Value', key: 'PobValue' },
        { head: 'RCPA Value For Own Brand', key: 'RcpaValueForOwnBrand' },
        { head: 'RCPA Value For Comp Brand', key: 'RcpaValueForCompBrand' },
        { head: 'Joint Work Total Calls', key: 'JointWorkTotalCalls' },
        { head: 'Primary DCRs', key: 'PrimaryDcrs' },
        // { head: 'Agenda', key: 'Agenda' },
        { head: 'Total Secondary', key: 'TotalSecondary' },
        { head: 'Secondary Met', key: 'SecondaryMet' },
        { head: 'Secondary Calls', key: 'SecondaryCalls' },
        { head: 'Secondary Call Avg', key: 'SecondaryCallAvg' },
        { head: 'Total Others', key: 'TotalOthers' },
        // { head: 'Primary Addition', key: 'PrimaryAddition' },
        // { head: 'Primary Deletion', key: 'PrimaryDeletion' },
        // { head: 'Created At', key: 'CreatedAt' },
        // { head: 'Updated At', key: 'UpdatedAt' },
        // { head: 'CAV Territories', key: 'CavTerritories' },
        // { head: 'Territory Id', key: 'TerritoryId' },
        // { head: 'Unique MAS Code', key: 'UniqueMasCode' },
        // { head: 'Position Id', key: 'PositionId' },
        // { head: 'Reporting To', key: 'ReportingTo' },
        // { head: 'Position Level', key: 'PositionLevel' },
        { head: 'Holiday Days', key: 'HolidayDays' },
        { head: 'POD Value', key: 'PodValue' },
        // { head: 'Primary Outlet Type', key: 'PrimaryOutletType' },
        // { head: 'Secondary Outlet Type', key: 'SecondayOutletType' },
        // { head: 'Other Outlet Type', key: 'OtherOutletType' },
    ];

    const captionTableHeader = masColumns.map((c, i) => ({ id: String(i + 1), head: c.head, key: c.key, sortKey: c.key }));


    const handleExportToExcel = () => {
        const exportData = displayedData.map(row => {
            const out: Record<string, any> = {};
            masColumns.forEach((c) => {
                out[c.head] = (row as any)[c.key] ?? '';
            });
            return out;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Effort Report");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Effort_Report_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    useEffect(() => {
        const fetchPositionIds = async () => {
            if (unitId) {
                const ids = await getFilteredPositionIds('Position', unitId);
                setSelectedIds(ids);
            }
        };

        fetchPositionIds();
    }, [unitId]);

    return (
        <div className='page-body p-2'>
            <Card>
                <div className='d-flex justify-content-between align-items-center pt-2 pb-2'>
                    <CardHeaderSpan headingClassName='pb-0' back={true} heading={ReportTitle} span={ReportListTitle} />
                    <div className='p-3'>
                        <RevMonth onChange={(value) => setSelectedMonth(value)} />
                    </div>
                </div>
                <div className="row px-3 mb-3 align-items-center justify-content-between">
                    <div className="col-md-8 d-flex align-items-center gap-3 flex-wrap">
                        <Input
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search by name or position"
                            className="form-control"
                            style={{ maxWidth: "250px" }}
                        />
                        <TreeModel onSelectionChange={setSelectedIds} />
                    </div>

                    {/* Right side: Download Button */}
                    <div className="col-md-4 d-flex justify-content-end gap-3">

                        <button
                            className="btn btn-sm btn-primary align-items-center d-flex "
                            onClick={handleExportToExcel}
                        >
                            <FeatherIconCom
                                iconName={"Download"}
                                size={14}
                                className="text-light"
                            />
                            <span className="px-2" style={{ fontSize: 14 }}>
                                Export
                            </span>
                        </button>

                    </div>
                </div>

                <Fragment>
                    <Container fluid>


                        <Row >
                            <Col sm={12} >
                                <div className="table-responsive ">


                                    {loading ? (
                                        <div className="text-center py-3">
                                            {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
                                            <div>
                                                <Image
                                                    className="b-r-10 img-80"
                                                    src={dynamicImage('dashboard/loader.gif')}
                                                    alt="Loading..."
                                                />
                                            </div>
                                        </div>
                                    ) : (

                                        <CommonTableNew
                                            caption=""
                                            headData={captionTableHeader}
                                            data={displayedData}
                                            renderRow={(row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {masColumns.map((c) => (
                                                        <td key={c.key}>{(row as any)[c.key] ?? '-'}</td> // Show '-' if no data
                                                    ))}
                                                </tr>
                                            )}
                                        />
                                    )
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            </Card>
        </div >
    );
}
